module.exports = __webpack_public_path__ + "img/tw.db1a8703.svg";